import api, { isTransientError } from "@/lib/api";
import { compressImage, isPdfFile } from "@/lib/imageCompress";

export const UPLOAD_TIMEOUT_MS = 120000;

/* Network / server trouble → worth retrying later. 4xx (except 429) means the file itself was rejected. */
export const shouldRetryLater = (err) => {
  const s = err?.response?.status;
  return isTransientError(err) || s === 429 || (s >= 500 && s < 600);
};

export async function uploadBlob(blob, { section, filename, mime, onProgress } = {}) {
  const type = mime || blob.type || "image/jpeg";
  const fd = new FormData();
  fd.append("file", new File([blob], filename || blob.name || "photo.jpg", { type }));
  fd.append("category", type === "application/pdf" ? "document" : "photo");
  fd.append("section", section || "property");
  const res = await api.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" }, timeout: UPLOAD_TIMEOUT_MS, retry: false,
    onUploadProgress: (e) => { if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100)); },
  });
  return res.data;
}

/* Compress (images) then upload a lead document; returns the public-doc shape used by the lead API. */
export async function uploadLeadDocument(file, onProgress) {
  const f = isPdfFile(file) ? file : await compressImage(file);
  const data = await uploadBlob(f, { section: "lead_document", filename: f.name, mime: f.type, onProgress });
  return { file_id: data.file_id, name: f.name, size: data.size ?? f.size, kind: isPdfFile(f) ? "pdf" : "image" };
}

export const fmtSize = (b) => (b == null ? "" : b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

/* Opens a protected file in a new tab (window opened synchronously so mobile popup blockers allow it). */
export async function openProtectedFile(fileId) {
  const win = window.open("", "_blank");
  try {
    const res = await api.get(`/files/${fileId}`, { responseType: "blob", retry: false, timeout: 60000 });
    const url = URL.createObjectURL(res.data);
    if (win) win.location.href = url; else window.open(url, "_blank", "noopener");
    setTimeout(() => URL.revokeObjectURL(url), 120000);
  } catch (err) {
    if (win) win.close();
    throw err;
  }
}

export const whatsappUrl = (phone, text) => {
  const digits = (phone || "").replace(/\D/g, "");
  const intl = digits.length === 10 ? `91${digits}` : digits;
  return `https://wa.me/${intl}?text=${encodeURIComponent(text)}`;
};
